<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="text-primary" width="16" height="14" viewBox="0 0 16 14">
        <path id="camera" d="M16,35.5v9A1.5,1.5,0,0,1,14.5,46H1.5A1.5,1.5,0,0,1,0,44.5v-9A1.5,1.5,0,0,1,1.5,34H4.25l.384-1.028A1.5,1.5,0,0,1,6.037,32H9.959a1.5,1.5,0,0,1,1.4.972L11.75,34H14.5A1.5,1.5,0,0,1,16,35.5ZM11.75,40A3.75,3.75,0,1,0,8,43.75,3.753,3.753,0,0,0,11.75,40Zm-1,0A2.75,2.75,0,1,1,8,37.25,2.754,2.754,0,0,1,10.75,40Z" transform="translate(0 -32)" class="fill-current"/>
    </svg>
</template>
